import { Component } from '@angular/core';
import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { AnalyticsService, NavigationService } from '@frk/eds-components';
import { StorageService } from '@services/storage.service';
import { InteractiveContentDisplayComponent } from '../../interactive-content-display-component.interface';

export const STORAGE_NAME_KEY = 'NJBEST_GET_STARTED_NAME';
export const STORAGE_AGE_KEY = 'NJBEST_GET_STARTED_AGE';

const TRACKING_DATA_LAYER = {
  name: 'njbest_get_started',
  event: 'quiz_engagement',
};

@Component({
  selector: 'ft-get-started',
  templateUrl: './get-started.component.html',
  styleUrls: ['../portfolio-selector/portfolio-selector.component.scss'],
})
export class GetStartedComponent implements InteractiveContentDisplayComponent {
  public config = {};
  public brLabels = {};

  public name = '';
  public age = 1;

  public ages = new Array(18);

  constructor(
    private storageService: StorageService,
    public navigationService: NavigationService,
    private analytics: AnalyticsService
  ) {}

  populate(config: any, labels: any, component: BrComponent, page: Page): void {
    if (config) {
      this.config = config;
    }

    if (labels) {
      this.brLabels = labels;
    }
  }

  public setName(name: string): void {
    this.name = name;
  }

  public setAge(age: string): void {
    this.age = Number(age);
    this.analytics.trackEvent({
      ...TRACKING_DATA_LAYER,
      action: 'age_change',
      label: age,
    });
  }

  public getStarted() {
    this.storageService.store(STORAGE_NAME_KEY, this.name, false);
    this.storageService.store(STORAGE_AGE_KEY, this.age, false);

    this.analytics.trackEvent({
      ...TRACKING_DATA_LAYER,
      action: 'get_started_button',
      label: this.brLabels['form-button'],
    });

    this.navigationService.navigateByUrl(this.config[`landingPage`]);
  }
}
